import React, { Component } from 'react';
import { Col, Row, Panel, FormGroup, FormControl, Button } from 'react-bootstrap';


class DamagedBarcodeSubmissionsSearch extends Component {
  render() {
    const {
      searchValue, onSearch, onClear, onInputChange, onStatusChange, status, statuses
    } = this.props;

    return (
      <Panel>
        <Row>
          <Col md={12}>
            <FormGroup>
              <FormControl
                placeholder="Search by id, customer_number, user_id..."
                value={searchValue}
                onChange={onInputChange}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={3}>
            <FormGroup>
              Status
              <FormControl
                componentClass="select"
                value={status}
                onChange={onStatusChange}
              >
                <option>All</option>
                {statuses && statuses.map((statusOption, index) =>
                  <option key={index} value={statusOption}>{statusOption}</option>)}
              </FormControl>
            </FormGroup>
          </Col>
          <Col md={6}>
          </Col>
          <Col md={3}>
            <Button
              className="red-ghost-btn"
              onClick={onSearch}
            >
              Search
            </Button>
            <Button
              className="red-ghost-btn"
              onClick={onClear}
            >
              Clear search
            </Button>
          </Col>
        </Row>
      </Panel>
    );
  }
}

export default DamagedBarcodeSubmissionsSearch;



// WEBPACK FOOTER //
// ./src/components/admin/scans/damaged-barcode-submissions/list/damaged-barcode-submissions-search.jsx